import { FC } from 'react';
import { Button, Row } from 'antd';

import { ModalComponent } from 'componets/common';

import { InvestmentsItem, ModalProps } from 'models';
import { InvestmentStatisticRow } from './InvestmentStatisticRow';
import { useTranslate } from 'hooks';

import styles from './index.module.scss';
interface InvestmentsModalProps extends ModalProps {
	values: InvestmentsItem[];
	title?: string;
}
export const InvestmentsModal: FC<InvestmentsModalProps> = ({ isOpen, onClose, values, title }) => {
	const t = useTranslate(['cancelText']);

	return (
		<ModalComponent
			isOpen={isOpen}
			onClose={onClose}
			title={title}
			className={styles.investmentsModal}
		>
			<div className="modal-content">
				<div className={styles.block}>
					<Row gutter={[0, 28]} className={styles.row}>
						{values.map((el, i: number) => (
							<InvestmentStatisticRow key={i} el={el} i={i} />
						))}
					</Row>
				</div>

				<div className="modal-footer">
					<Button type="default" role="button" onClick={onClose} className={styles.cancel}>
						{t.cancelText}
					</Button>
				</div>
			</div>
		</ModalComponent>
	);
};
